var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTasks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "1 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4027 3.36723C19.7521 3.58961 19.8551 4.05317 19.6327 4.40263L12.6327 15.4026C12.5106 15.5946 12.308 15.7207 12.0818 15.7455C11.8557 15.7703 11.6305 15.6912 11.4697 15.5303L8.46967 12.5303C8.17678 12.2374 8.17678 11.7625 8.46967 11.4696C8.76256 11.1767 9.23744 11.1767 9.53033 11.4696L11.8692 13.8085L16.591 6.38851C15.3405 5.36396 13.7426 4.74997 12 4.74997C7.99594 4.74997 4.75 7.99591 4.75 12C4.75 16.004 7.99594 19.25 12 19.25C16.0041 19.25 19.25 16.004 19.25 12C19.25 11.0372 19.0627 10.1199 18.7233 9.28138C18.5679 8.89743 18.7531 8.46019 19.1371 8.30477C19.521 8.14935 19.9583 8.33461 20.1137 8.71856C20.5243 9.73288 20.75 10.841 20.75 12C20.75 16.8325 16.8325 20.75 12 20.75C7.16751 20.75 3.25 16.8325 3.25 12C3.25 7.16748 7.16751 3.24997 12 3.24997C14.0378 3.24997 15.914 3.94736 17.4011 5.1155L18.3673 3.59732C18.5896 3.24786 19.0532 3.14485 19.4027 3.36723Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasks);
export default __webpack_public_path__ + "static/media/tasks.80ca5d76.svg";
export { ForwardRef as ReactComponent };